import { useAppDataStore } from '@stores/useAppDataStore';
import { pinia } from '@tools/pinia';

export const appData = () => {
  const appDataStore = useAppDataStore(pinia);
  appDataStore.init();
};
